<template>
  <section class="RichText" v-html="text"></section>
</template>

<script>
import "@/components/Richtext/Richtext.scss";

export default {
  name: "Richtext",

  props: {
    text: String,
  },
};
</script>
